export default __webpack_public_path__ + "static/media/logo2.a5764a5f.svg";